module.exports = __webpack_public_path__ + "assets/img/like-off.b8043fae.svg";